import React from 'react';
import { Icons } from '../../assets';
import { Cred } from '../../models';

type Props = {
  cred: Cred;
  handleCredDetailsClicked: () => void;
};
export const CredInteractionDetails: React.FC<Props> = ({ cred, handleCredDetailsClicked }) => (
  <div className="py-3 d-flex align-items-center gap-1">
    <div className="d-flex flex-grow-1 justify-content-between" style={{ width: '100%' }}
      onClick={handleCredDetailsClicked}
    >
      <span className="fw-semibold d-flex align-items-center gap-2" style={{ color: '#2B2B2B', fontSize: '12px' }}>
        <img
          src={Icons.RECCO_HIFIS}
          alt="HIFI"
        />
        {cred?.hifiCount || '0'}
        <span className='fw-medium' style={{ color: '#2E7CF6' }}>
          {"Hi-fi's"}
        </span>
      </span>
      <span className="fw-semibold d-flex align-items-center gap-2" style={{ color: '#2B2B2B', fontSize: '12px' }}>
        <img
          src={Icons.RECCO_COMMENTS}
          alt="Comment"
        />
        {cred?.commentCount}
        <span className='fw-medium' style={{ color: '#2E7CF6' }}>
          {"Comments"}
        </span>
      </span>
      <span className="fw-semibold d-flex align-items-center gap-2" style={{ color: '#2B2B2B', fontSize: '12px' }}>
        <img
          src={Icons.RECCO_SHARES}
          alt="Shares"
        />
        <span className='fw-medium' style={{ color: '#2E7CF6' }}>
          {"Shares"}
        </span>
      </span>
    </div>
  </div>
);
